import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { CheckInDto } from '../../check-ins/dtos/check-in.dto';
import { CheckOutDto } from '../../check-outs/dtos/check-out.dto';

import { CreateRentalAgreementDto } from './create-rental-agreement.dto';

/**
 * Names an existing agreement to update. Booker and driver fields follow
 * the create body.
 */
export class UpdateRentalAgreementDto extends CreateRentalAgreementDto {
  @TransformInt()
  id!: number;
  documentNumber!: string;
  checkIns?: CheckInDto[] | null;
  checkOuts?: CheckOutDto[] | null;
}
